import React, { FC, useState } from 'react'
import { IonSpinner } from '@ionic/react'
import { observer } from 'mobx-react'
import { discountMobx } from '@mobx/mall'
import { memberMobx } from '@mobx/mkt'
import { payPlanMobx } from '@mobx/mall/payment'
import { modalLayer, toastLayer } from '@utils'
import GiftCardAmountModal from '@pages/checkout/modal/GiftCardAmountModal'
import './index.scss'

interface IProps {
  isForbidGiftCard?: boolean;
}

const CodeInputBar: FC<IProps> = ({ isForbidGiftCard = false }) => {
  const [value, setValue] = useState('')
  const [loading, setLoading] = useState(false)

  return (
    <div className='code-input-bar-wrapper'>
      <div className='code-input-bar'>
        <input
          onChange={(e) => {
            setValue(e.target.value)
          }}
          value={value}
          placeholder={isForbidGiftCard ? i18n.t('checkout.input_promocode') : i18n.t('checkout.input_promocode_or_giftcard')}
          onBlur={(e) => {
            const upperCaseValue = e.target.value.toLocaleUpperCase()
            setValue(upperCaseValue)
          }}
        />
        <span
          onClick={async () => {
            if (value && value.length >= 6) {
              if (await discountMobx.verifyPromoCode(value)) {
                const exitCodes = discountMobx.discountAction.promoCodes
                discountMobx.setPromoCodes([...exitCodes, value])
                toastLayer.success(i18n.t('checkout.promocode_use_success_need_check'))
                setValue('')
              } else if (!isForbidGiftCard) {
                setLoading(true)
                try {
                  const card = await memberMobx.checkoutAddGiftCard(value)
                  const amount = await modalLayer<{ card: IMemberGiftCardInfo }, number>(GiftCardAmountModal, { card }, 'giftCardAmountModal')
                  payPlanMobx.setGiftCardPayAmount(card, amount)
                  setValue('')
                } catch (e) {
                  if (e && e.message) {
                    toastLayer.error({
                      content: e.message,
                      duration: 1000,
                    })
                  }
                } finally {
                  setLoading(false)
                }
              }
            }
          }}
          className={value.length >= 6 ? 'actived' : ''}
        >
          {loading ? <IonSpinner /> : <i className='iconfont icon-check'></i>}
        </span>
      </div>
      {/* {memberMobx.giftCardListForPay && memberMobx.giftCardListForPay.length > 0 && (
        <div className='select-gift-card'>
          <span onClick={() => modalLayer(SelectGiftCardModal, null, 'selectGiftCardModal')}>{i18n.t('pay.selectGiftCardFromWallet')}</span>
        </div>
      )} */}
    </div>
  )
}
export default observer(CodeInputBar)
